module.exports = __webpack_public_path__ + "img/wechat.3c00d466.png";